import { z } from "zod/v4-mini";

import { TandemResponse } from "@/lib/drivers/tandem/TandemTypes";
import { Schema } from "@/utils/zodUtils";

export type ACKPayload = {
  msg_id: number;
  success: number;
};

export const ackPayloadSchema: Schema<ACKPayload> = z.object({
  msg_id: z.number(),
  success: z.number(),
});

export const COMMAND_ACK_RESPONSE = {
  value: 123,
  name: "Command Acknowledge",
  version: 36102,
  format: "bb",
  fields: ["msg_id", "success"],
  postprocess: rec => rec,
  schema: ackPayloadSchema,
} as const satisfies TandemResponse<ACKPayload>;
